/* eslint-disable arrow-parens, eqeqeq, no-use-before-define */
// arrow-parens: parens rule valid when there's only one arguement,
// one argument not feasible therefore linter rule incompatible with conditional logic structure
// eqeqeq: data.success not controlled, allow for non explict failure states
// no-use-before-define: linter rule does not work well with module export syntax

// File is structured this way to make it testable in jest.
// module export syntax used as jest spy can only test functions that are called as object methods.

// https://medium.com/@DavideRama/mock-spy-exported-functions-within-a-single-module-in-jest-cdf2b61af642
// https://stackoverflow.com/questions/52650367/jestjs-how-to-test-function-being-called-inside-another-function

import axios from 'axios';
import sharedFunctions from '../shared_functions/shared_functions';

const handleEvent = (event) => {
  if (event.target.hasAttribute('data-form-handler') 
    && event.target.getAttribute('data-form-handler') === 'js') {
    formAjax.setupDataFormHandlerJs(event);
  }
};

const getElementOffset = (el) => {
  // util for getting the offset/position of an element
  const de = document.documentElement;
  const box = el.getBoundingClientRect();
  const top = box.top + window.pageYOffset - de.clientTop;
  const left = box.left + window.pageXOffset - de.clientLeft;
  return { top: top, left: left };
};

const setupDataFormHandlerJs = (event) => {
  event.preventDefault();
  const formData = sharedFunctions.serializeArray(event.target);
  let encodeFormData;

  // jump to the top of the form if needed
  const elOffset = getElementOffset(event.target);
  if (elOffset.top < window.pageYOffset) {
    // if the top of the form is above the viewable area, we will scroll up to the top of the form
    window.scrollTo(elOffset.left, elOffset.top);
  }

  if (event.target.getAttribute('enctype') === 'multipart/form-data') {
    encodeFormData = new FormData();
    // for - of not compatible with IE11. Babel should catch this.
    for (const object of formData) {
      encodeFormData.append(object.name, object.value);
    }
  } else {
    const serialized = [];
    formData.forEach(field => serialized.push(encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)));
    encodeFormData = serialized.join('&');
  }
  event.target.innerHTML = '<div class="sb-formbuilder-loading"><i class="fa fa-refresh fa-spin fa-2x fa-fw" aria-hidden="true"></i></div>';
  formAjax.postDataFormHandlerJs(encodeFormData, event);
};

const responseHandler = (event, response) => {
  if (response.data.content) {
    // html content is returned
    // using setInnerHtml to execute script loading of the innerHTML content
    sharedFunctions.setInnerHtml(event.target, response.data.content);
  } else if (response.data.redirect_after_success_url) {
    // instead of content, the response says we should redirect
    window.location = response.data.redirect_after_success_url;
  }
  // note: we want the events to fire after the innerHTML above,
  // so users of the event will have the DOM changes to work with
  if (response.data.success) {
    // successful submit event
    let e;
    if (window.CustomEvent && typeof window.CustomEvent === 'function') {
      e = new CustomEvent('ajax-form-success', { bubbles: true, cancelable: false });
    } else {
      e = document.createEvent('CustomEvent');
      e.initCustomEvent('ajax-form-success', true, true);
    }
    event.target.dispatchEvent(e);
  } else if (response.data.success == false) {
    // form had validation errors
    let e;
    if (window.CustomEvent && typeof window.CustomEvent === 'function') {
      e = new CustomEvent('ajax-form-failure', { bubbles: true, cancelable: false });
    } else {
      e = document.createEvent('CustomEvent');
      e.initCustomEvent('ajax-form-failure', true, false);
    }
    event.target.dispatchEvent(e);
  }
};

const postDataFormHandlerJs = (encodeFormData, event) => {
  const url = (window.formBaseDirectory || '/') + 'modules/formbuilder/form_ajax/';
  let postHeaders = {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
  };
  if (event.target.getAttribute('enctype') === 'multipart/form-data') {
    postHeaders = {
      'Content-Type': 'multipart/form-data;',
    };
  }
  let e;
  if (window.CustomEvent && typeof window.CustomEvent === 'function') {
    e = new CustomEvent('ajax-form-progress', { bubbles: true, cancelable: false });
  } else {
    e = document.createEvent('CustomEvent');
    e.initCustomEvent('ajax-form-progress', true, true);
  }
  axios({
    method: 'POST',
    url: url,
    data: encodeFormData,
    headers: postHeaders,
    onUploadProgress: function (progressEvent) {
      e.progressEvent = progressEvent;
      // console.log(e.progressEvent);
      // const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
      // console.log(progressEvent);
      // console.log(percentCompleted);
      event.target.dispatchEvent(e);
    },
  })
  .then(
    response => {
      responseHandler(event, response);
    },
  );
};

// These blocks of code are what allow for testing
// To test functions they must be object methods which requires export default module syntax (instead of require) ->
// export default module syntax loads before test file globals meaning event is undefined (jsdom handles listeners different than web browsers) ->
// this normally can be circumvented by defining jest globals in jest.config.js ->
// however document elements can not be defined because document does not exist when jest.config is loaded

if (window.sb && window.sb.test !== true) {
  document.addEventListener('submit', handleEvent);
}

const formAjax = {
  handleEvent,
  postDataFormHandlerJs,
  responseHandler,
  setupDataFormHandlerJs,
};

export default formAjax;
